import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import type { GiftProductDetail } from '@/api/getGiftProductDetail';
import { getYearEndGoodsGift } from '@/constants/yearEndGoodsGift';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';
import { useSelectedDonationAmount } from '../_components/GiftDetailTemplate/useSelectedDonationAmount';

//* 상세는 ISR(30분)이라 잔여·마감은 지역 단건 API로 따로 받는다 — 바로 보여야 해서 캐시하지 않는다
const EDITION_STALE_TIME = 0;

//* 주문서와 같이 수량·옵션을 합친 기부 금액을 서버 대상 금액과 비교한다 — 상세 응답 edition은 1개 가격 기준이라 쓰지 않는다
export const useEditionGoodsGift = product => {
  const $ = _c(11);
  const {
    entry,
    isEntryResolved
  } = useWebviewTypeEntry();
  let t0;
  if ($[0] !== entry || $[1] !== product?.institutionId) {
    t0 = UnauthQueryOptions["get:/wello/v2/allows/hometown-edition/regions/{homeInstitutionId}"]({
      path: {
        homeInstitutionId: product?.institutionId ?? 0
      },
      query: {
        entry
      }
    });
    $[0] = entry;
    $[1] = product?.institutionId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = !!product && isEntryResolved;
  let t2;
  if ($[3] !== t0 || $[4] !== t1) {
    t2 = {
      ...t0,
      enabled: t1,
      staleTime: EDITION_STALE_TIME,
      select: _temp
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: edition
  } = useQuery(t2);
  let t3;
  if ($[6] !== edition) {
    t3 = getYearEndGoodsGift(edition);
    $[6] = edition;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const goodsGift = t3;
  const t4 = product?.currentPrice;
  const t5 = product?.requiredDonationAmount ?? 0;
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = {
      currentPrice: t4,
      requiredDonationAmount: t5
    };
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const {
    totalDonationAmount
  } = useSelectedDonationAmount(t6);
  if (!goodsGift || totalDonationAmount < goodsGift.minDonationAmount) {
    return null;
  }
  return goodsGift;
};
function _temp(response) {
  return response.context?.edition ?? null;
}